import { gql } from "@apollo/client";

const GET_DOCUMENT_LIST = gql`
  query GET_DOCUMENT_LIST($hcpId: ObjectId, $hcfId: ObjectId, $shiftId: ObjectId) {
    documentList(hcpId: $hcpId, hcfId: $hcfId, shiftId: $shiftId) {
      _id
      name
      hcpId
      displayName
      issueDate
      expiry
      covidTest
      visible
      status
      state
      multiState
      subType
      createdAt
      uploadedFor {
        _id
        name
      }
      fulfilledRequirement {
        _id
        name
      }
      rejectionNotifiedAt
      notification {
        note
        pushNotification
        reason
      }
      requirement {
        expiryType
      }
    }
  }
`;

export { GET_DOCUMENT_LIST };
